import { ref, type Ref } from 'vue'

interface AppState {
  title: Ref<string>
  searchEnabled: Ref<boolean>
  searchPlaceholder: Ref<string>
  snackbar: Ref<{
    show: boolean
    message: string
    duration: number
  }>
}

const appState: AppState = {
  title: ref(''),
  searchEnabled: ref(false),
  searchPlaceholder: ref('Search...'),
  snackbar: ref({
    show: false,
    message: '',
    duration: 6000
  })
}

export const useAppState = () => {
  const setTitle = (title: string) => {
    appState.title.value = title
  }

  const enableSearch = (placeholder?: string) => {
    appState.searchEnabled.value = true
    if (placeholder) {
      appState.searchPlaceholder.value = placeholder
    }
  }

  const disableSearch = () => {
    appState.searchEnabled.value = false
    appState.searchPlaceholder.value = 'Search...'
  }

  const showSnackbar = (message: string, duration: number = 6000) => {
    appState.snackbar.value = {
      show: true,
      message,
      duration
    }
  }

  const hideSnackbar = () => {
    appState.snackbar.value.show = false
  }

  return {
    // State (readonly access)
    title: appState.title,
    searchEnabled: appState.searchEnabled,
    searchPlaceholder: appState.searchPlaceholder,
    snackbar: appState.snackbar,

    // Actions
    setTitle,
    enableSearch,
    disableSearch,
    showSnackbar,
    hideSnackbar
  }
}
